import React from 'react';
import { connect } from 'react-redux';
import Link from 'next/link';
import css from './Breadcrumb.less';

const Breadcrumb = props => {
  const { city, institution } = props;
  const { currentCity } = city;
  const { shop } = institution;
  return (
    <div className={css.content}>
      <p className={css.item}>{currentCity.name}</p>
      <p className={css.item}>服务分类</p>
      {shop.navigation_category && shop.navigation_category.id ? (
        <Link
          href={{
            pathname: '/category/[id]/[type]/',
          }}
          as={{
            pathname: `/category/${shop.navigation_category.id}/1/`,
          }}
        >
          <a className={css.item}>{shop.navigation_category.name}</a>
        </Link>
      ) : null}
      {shop.navigation_category &&
      shop.navigation_category.show_level_category.id ? (
        <Link
          href={{
            pathname: '/category/[id]/[type]/',
          }}
          as={{
            pathname: `/category/${shop.navigation_category.show_level_category.id}/2/`,
          }}
        >
          <a className={css.item}>
            {shop.navigation_category.show_level_category.name}
          </a>
        </Link>
      ) : null}
    </div>
  );
};

export default connect(({ city, institution }) => ({
  city,
  institution,
}))(Breadcrumb);
